import { render, staticRenderFns } from "./user_mass_assignment_selection.vue?vue&type=template&id=23513165&scoped=true&"
import script from "./user_mass_assignment_selection.vue?vue&type=script&lang=js&"
export * from "./user_mass_assignment_selection.vue?vue&type=script&lang=js&"
import style0 from "./user_mass_assignment_selection.vue?vue&type=style&index=0&id=23513165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23513165",
  null
  
)

export default component.exports